<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\jonh_live_new_1.png" alt="" /></div>
                <div>
                    <p>① Sau khi tìm đúng khóa học bạn muốn tham gia (Đúng tên khóa học, ngày giảng, thời gian bắt đầu, …) thì nhấn vào tên khóa học để tham gia khóa học.</p>
                </div>
                <div><img src="/static\images\vi\newManual\jonh_live_new_2.png" alt="" /></div>
                <div>
                    <p>② Nhấn nút [Tham gia] để vào phòng học. Nếu vẫn không thể vào phòng học thì tiếp tục bước ⑨</p>
                    <p>③ Tuy nhiên, trong trường hợp nhấn nút [Tham gia] nhưng vẫn không thể vào được phòng học, thì hãy nhấn nút [Dự phòng] để tham gia khóa học.</p>
                    <p>&nbsp; Lưu ý: trường hợp vào phòng bằng nút [Dự phòng] thì bạn sẽ không được điểm danh cho khóa học này.</p>
                </div>
                <div><img src="/static\images\vi\newManual\jonh_live_new_3.png" alt="" /></div>
                <div>
                    <p>④ Do đó, sau khi buổi học kết thúc, hãy nhấn vào tên khóa học 1 lần nữa.</p>
                </div>
                <div><img src="/static\images\vi\newManual\jonh_live_new_4.png" alt="" /></div>
                <div>
                    <p>⑤ Sau khi nhấn vào tên khóa học đã kết thúc, thông báo có nội dung như bên trên sẽ xuất hiện.</p>
                    <p>Nhấn vào nút [Điểm danh] để điểm danh cho khóa học.</p>
                </div>
                <div>
                    <h1>Trường hợp không tìm thấy khóa học online của ngày hôm nay, hoặc không tham gia vào khóa học hôm nay được.</h1>
                </div>
                <div><img src="/static\images\vi\newManual\jonh_live_new_5.png" alt="" /></div>
                <div>
                    <p>① Tìm kiếm khóa học của ngày hôm trước bằng tính năng tìm kiếm khóa học như đã trình bày ở trên.</p>
                    <p>② Nhấn vào tên khóa học đã tìm thấy (lúc này đang trong trạng thái kết thúc).</p>
                    <p>③ Thông báo bên trên sẽ xuất hiện.</p>
                    <p>&nbsp; Nhấn vào nút [Vào lại phòng] để có thể tham gia được khóa học của ngày hôm nay.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>1. Bạn muốn tham gia khóa học.</p></div>
                <div><p>1.1. Nhấn vào tên khóa học bạn muốn tham gia.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_3_1.png" alt="" /></div>
                <div><p>1.2. Nhấn vào nút [Tham gia].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_3_2.png" alt="" /></div>
                <div><p>1.3. Tại đây sẽ xuất hiện thông báo, bạn hãy nhấn vào nút [Tham gia]. Trường hợp không tham gia được, bạn hãy nhấn vào nút [Dự phòng] để vào phòng học nhưng đối với link dự phòng thì bạn sẽ không được điểm danh.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_3_3.png" alt="" /></div>
                <div><p>❖ Chú ý trường hợp bạn nhấn vào nút dự phòng thì hệ thống sẽ không điểm danh cho bạn. Nếu bạn muốn điểm danh thì sau khi khóa học đã kết thúc bạn nhấn lại tham gia và tự điểm danh cho mình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_3_4.png" alt="" /></div>
                <div><p>2 Trường hợp cả khóa đó không click vào tham gia khóa học được thì bạn có thể thống nhất với bạn học và thầy cô vô lại khóa học cũ để tham gia học(Với trường hợp này là chỉ sử dụng với sự cố hy hữu khi xảy ra).</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/jonhLiveCourse_manual.vue